/**
 * A regular expression pattern that matches U.S. state abbreviations.
 *
 * @example
 * if (stateAbbreviationPattern.test('CA')) {
 *   console.log('"CA" is a U.S. state abbreviation.')
 * }
 */
export const stateAbbreviationPattern =
  /^(A[KLRZ]|C[AOT]|D[CE]|FL|GA|HI|I[ADLN]|K[SY]|LA|M[ADEINOST]|N[CDEHJMVY]|O[HKR]|PA|RI|S[CD]|T[NX]|UT|V[AT]|W[AIVY])$/

/**
 * A regular expression pattern that matches Canadian province abbreviations.
 *
 * @example
 * if (canadianProvinceAbbreviationPattern.test('ON')) {
 *   console.log('"ON" is a Canadian province abbreviation.')
 * }
 */
export const canadianProvinceAbbreviationPattern =
  /^(AB|BC|MB|NB|NL|NS|NT|NU|ON|PE|QC|SK|YT)$/

/**
 * A regular expression pattern that matches any whole number.
 *
 * @example
 * if (anyNumberPattern.test('123-456-7890')) {
 *   console.log('"123-456-7890" contains numbers and hyphens.')
 * }
 */
export const anyNumberPattern = /^[0-9-]+$/

/**
 * A regular expression pattern that matches U.S. zip codes
 * (e.g. 12345, 12345-6789).
 * @example
 * if (zipCodePattern.test('12345')) {
 *  console.log('"12345" is a U.S. zip code.')
 * }
 */
export const zipCodePattern = /\d{5}(?:[-\s]\d{4})?/

/**
 * A regular expression pattern that matches Canadian postal codes
 * (e.g. A1A 1A1).
 * @example
 * if (canadianPostalCodePattern.test('A1A 1A1')) {
 *  console.log('"A1A 1A1" is a Canadian postal code.')
 * }
 */
export const canadianPostalCodePattern = /[A-Z]\d[A-Z] \d[A-Z]\d/
